
import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import DiscountConfigurationForm from '@/components/discount/DiscountConfigurationForm';
import DiscountHistoryTab from '@/components/discount/DiscountHistoryTab';

const DiscountAnalysis = () => {
  const [activeTab, setActiveTab] = useState('analysis');

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4 max-w-full">
        <h1 className="text-2xl font-bold text-center mb-2">Discount Analysis</h1>
        <p className="text-gray-500 text-center mb-8">
          Analyze vendor discounts and price trends
        </p>
        
        <Card className="w-full">
          <CardHeader>
            <CardTitle>Discount Analysis Dashboard</CardTitle>
            <CardDescription>
              Configure and analyze discount settings
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
              <TabsList className="grid w-full grid-cols-2 mb-6">
                <TabsTrigger value="analysis">Analysis</TabsTrigger>
                <TabsTrigger value="history">History</TabsTrigger>
              </TabsList>
              
              <TabsContent value="analysis">
                <DiscountConfigurationForm />
              </TabsContent>
              
              <TabsContent value="history">
                <DiscountHistoryTab />
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DiscountAnalysis;
